import { useState } from "react";
import { useContextDashboardContext } from "src/Contexts/Dashboard/ContextDashboardBroker";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const UseFormInstallmentsReceived = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const {
    filterMetricsFilterDashboard: { endDate, startDate, interval },
  } = useContextDashboardContext();

  const { setDataInstallmentsReceived } = useContextDashboardContext();

  const [loading, setLoading] = useState(false);

  const handleGet = async () => {
    setLoading(true);

    return api
      .get(
        `/metrics/confirmedInstallments?startDate=${startDate}&endDate=${endDate}&interval=${interval}&numberInstallment=ALL`
      )
      .then((res) => {
        setDataInstallmentsReceived(res.data);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleSubmit: handleGet, loading };
};
